/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { Box, BoxProps } from '@chakra-ui/react';
import React, { ReactNode, useEffect } from 'react';

interface OverlayProps {
  ref: React.RefObject<HTMLDivElement>;
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

const Overlay = ({ children, isOpen, onClose, ref }: OverlayProps) => {
  const [topPosition, setTopPosition] = React.useState(0);
  const [leftPosition, setLeftPosition] = React.useState(0);

  useEffect(() => {
    const referenceRect = ref.current?.getBoundingClientRect();
    if (!referenceRect) {
      return;
    }
    setTopPosition(referenceRect.bottom);
    setLeftPosition(referenceRect.left);
  }, [ref]);

  if (!isOpen) {
    return null;
  }

  const boxProps: BoxProps = {
    position: 'fixed',
    top: `${topPosition}px`,
    left: `${leftPosition}px`,
    zIndex: '1', // Set the z-index lower than the reference element
    onClick: onClose, // Close the overlay when clicked (optional)
  };

  return <Box {...boxProps}>{children}</Box>;
};

export default Overlay;
